import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { PAGE } from '../libs/constants';
import { PageType } from '../libs/types';

/** Returns the 'human-readable' name of the page. */
export const usePageName = (): PageType => {
  const { pathname } = useRouter();

  return useMemo(() => {
    switch (pathname) {
      case '/user/[userId]/folder/[folderId]':
        return PAGE.MVV;
      case '/home':
        return PAGE.ELIHP;
      case '/library/showcases':
        return PAGE.SHOWCASES;
      case '/library-search':
        return PAGE.VLS;
      case '/search/[[...slug]]':
        return PAGE.SEARCH;
      case '/library':
        return PAGE.LIBRARY;
      case '/library/events':
        return PAGE.EVENTS;
      case '/manage/videos/[videoId]':
        return PAGE.SVV;
      case '/shared-with-me':
        return PAGE.SHARED_WITH_ME;
      default:
        return PAGE.UNKNOWN;
    }
  }, [pathname]);
};
